import axios from "axios";
import { useState } from "react";
import { useAuth } from "../Contexts/AuthContext";
import { generateStrongPassword, togglePasswordVisibility, copyPasswordToClipboard } from './passwordUtils';

const AdminSettings = () => {
  const [currentPassword, setCurrentPassword] = useState<string>("");
  const { user, updatePassword, enable2Fa, disable2Fa } = useAuth();
  const [newPassword, setNewPassword] = useState<string>("");
  const [passwordStrength, setPasswordStrength] = useState<number>(0);
  const [passwordFeedback, setPasswordFeedback] = useState<string>("");
  const [showPassword, setShowPassword] = useState<boolean>(false);
  const [is2FAEnabled, setIs2FAEnabled] = useState(user?.twoFactorEnabled);

  const handleChangePassword = async () => {
    await updatePassword(currentPassword, newPassword);
    setCurrentPassword("");
    setNewPassword("");
  };

  const handle2FAToggle = async () => {
    if (is2FAEnabled) {
      await disable2Fa();
    } else {
      await enable2Fa();
    }
    setIs2FAEnabled(!is2FAEnabled);
  };

  return (
    <div className="admin-settings">
      <h1>Change Password</h1>
      <div className="admin-settings-form">
        <input
          type="password"
          placeholder="Current Password"
          value={currentPassword}
          onChange={(e) => setCurrentPassword(e.target.value)}
          className="admin-settings-form__input"
        />
        <input
          type={showPassword ? "text" : "password"}
          placeholder="New Password"
          value={newPassword}
          onChange={(e) => setNewPassword(e.target.value)}
          className="admin-settings-form__input"
        />
        <div className="admin-settings-form-button-section">
          <button onClick={handleChangePassword} className="admin-settings-form__button">Change Password</button>
          <button onClick={() => generateStrongPassword(setNewPassword, setPasswordStrength, setPasswordFeedback)} className="admin-settings-form__button">Generate Strong Password</button>
          <button onClick={() => togglePasswordVisibility(showPassword, setShowPassword)} className="admin-settings-form__button">
            {showPassword ? "Hide" : "Show"} Password
          </button>
          <button onClick={() => copyPasswordToClipboard(newPassword)} className="admin-settings-form__button">Copy Password</button>
        </div>
        <p>Password Strength: {passwordStrength}</p>
        <p>{passwordFeedback}</p>
      </div>

      <h1>Two Factor Authentication</h1>
      <p>Two Factor Authentication is currently {is2FAEnabled ? "enabled" : "disabled"}</p>
      <button onClick={handle2FAToggle} className="admin-settings-form__button--primary">
        {is2FAEnabled ? "Disable" : "Enable"} Two Factor Authentication
      </button>
    </div>
  );
};

export default AdminSettings;